<template>
  <div>
    <div class="superuser-search__top">
      <validation-observer
        ref="superuserSearch"
        tag="form"
        class="superuser-search__form"
        @submit.prevent
        @keyup.enter="searchCustomer()">
        <oie-base-input
          id="customerNumber"
          v-model="customerNumber"
          :label-text="t('superuserCustomerSearchLabel')"
          class="superuser-search__input"
          @blur="clearQuery()"
          @keyup="clearQuery()"></oie-base-input>
        <oie-base-input
          id="query"
          v-model="query"
          :label-text="t('superuserCustomerFreeTextSearchLabel')"
          class="superuser-search__input-wide"
          data-pw="superuser-search-query"
          @blur="clearCustomerNumber()"
          @keyup="clearCustomerNumber()"></oie-base-input>
        <oie-base-button
          v-element-loader="{ endpoint: 'superuser/search' }"
          css-classes="button--with-border button--blue supseruser-search__action"
          :text="t('superuserCustomerSearchButtonLabel')"
          data-pw="superuser-search-button"
          @click="searchCustomer()"></oie-base-button>
      </validation-observer>

      <div v-if="markets && markets.length > 0" class="superuser-search__sign-in">
        <oie-base-dropdown
          v-model="selectedMarket"
          :label-text="t('superuserSearchMarket')"
          :default-selected="createDefaultSelection"
          :options="markets"
          name="superuser-sign-up"
          class="superuser-search__market-dropdown"></oie-base-dropdown>

        <oie-base-button
          v-element-loader="{ endpoint: 'superuser/impersonateAnonymous' }"
          css-classes="button--with-border button--blue supseruser-impersonate__action"
          data-pw="login-anonymous-button"
          :text="t('superuserSearchAnonymousButtonLabel')"
          @click="impersonateAnonymous()"></oie-base-button>
      </div>
    </div>

    <oie-superuser-search-result :rows="customerRows"></oie-superuser-search-result>
  </div>
</template>

<script>
import httpService from '@/core/http-service'
import _ from 'lodash'
import Vue from 'vue'

export default {
  data: () => ({
    query: null,
    customerNumber: null,
    customerRows: null,
    markets: null,
    selectedMarket: null
  }),
  computed: {
    createDefaultSelection() {
      return this.markets.find(m => m.value.toUpperCase() === this.clientModel.currentMarket.toUpperCase()).value
    }
  },
  mounted() {
    if (this.markets === null) {
      httpService.get('superuser/markets')
        .then(({ data }) => {
          this.markets = this.formatMarketDropdownData(data)
        })
    }

    this.subscribe('superuser-user-updated', this.updateUser)

    this.subscribe('superuser-update-and-reset-user-data', this.updateUser)

    this.subscribe('superuser-user-removed', (userId) => {
      var ix = _.findIndex(this.customerRows, (row) => { return row.userId === userId })
      if(ix > -1) {
        let customer = JSON.parse(JSON.stringify(this.customerRows[ix]))
        customer.removed = true
        this.customerRows.splice(ix, 1, customer)
        // this.customerRows[ix].removed = true
      }
    })

    this.subscribe('superuser-reset-user-data', ({ originalValues, index }) => {
      Vue.set(this.customerRows, index, originalValues)
    })

    this.subscribe('superuser-search-customer-number', (customerNumber) => {
      this.customerNumber = customerNumber
      this.query = null
      this.searchCustomer()
    })

    // Refresh cached rows so payer details reflect the import
    this.subscribe('superuser-customer-imported', () => {
      if (this.customerRows) this.searchCustomer()
    })
  },
  methods: {
    async searchCustomer() {
      const isValid = await this.$refs.superuserSearch.validate()

      if (!isValid) {
        return
      }

      httpService.post('superuser/search', { query: this.query, customerNumber: this.customerNumber })
        .then(({ data }) => {
          this.customerRows = data
        })
    },
    impersonateAnonymous() {
      window.location = `/mvcapi/se/sv/superuser/impersonateAnonymous?market=${this.selectedMarket}`
    },
    formatMarketDropdownData(data) {
      return data.map((market) => {
        return {
          value: market.marketId,
          text: market.name
        }
      })
    },
    clearCustomerNumber() {
      if (this.customerNumber && this.query) {
        this.customerNumber = null
      }
    },
    clearQuery() {
      if (this.query && this.customerNumber) {
        this.query = null
      }
    },
    updateUser({ user }) {
      var ix = _.findIndex(this.customerRows, (row) => { return row.userId === user.userId })
      if(ix > -1) {
        this.customerRows.splice(ix, 1, user)
      }
    }
  }
}
</script>

<style lang="scss">
.superuser-search__top {
  display: flex;
  flex-direction: column;
  margin-bottom: measure(full);

  @include media(medium) {
    flex-direction: row;
  }
}

.superuser-search__form {
  display: flex;
  flex-direction: column;
  width: 100%;
  order: 1;

  @include media(small) {
    flex-direction: row;
    max-width: 40rem;
  }

  @include media(medium) {
    order: initial;
  }
}

.superuser-search__input,
.superuser-search__input-wide {
  min-width: 10rem;
  max-width: 20rem;
  margin-bottom: measure(quarter);

  @include media(small) {
    margin-bottom: 0;
    margin-right: measure(half);
  }
}

.superuser-search__input-wide {
   min-width: 20rem;
}

.supseruser-search__action {
  width: 100%;

  @include media(small) {
    width: auto;
    min-width: 9rem;
    margin-top: 1.6875rem;
  }
}

.supseruser-import__action {
  width: 100%;
  margin-left: measure(half);

  @include media(small) {
    width: auto;
    min-width: 9rem;
    margin-top: 1.6875rem;
  }
}

.supseruser-impersonate__action {
  width: 100%;

  @include media(small) {
    width: auto;
    min-width: 9rem;
    margin-top: 1.6875rem;
  }
}

.superuser-search__sign-in {
  display: flex;
  flex-direction: column;
  margin-bottom: measure(double);
  margin-left: 0;
  order: 0;

  @include media(small) {
    flex-direction: row;
  }

  @include media(medium) {
    order: initial;
    margin-bottom: 0;
    margin-left: auto;
  }
}

.superuser-search__sign-in > * {
  flex-shrink: 0;
}

.superuser-search__market-dropdown {
  width: 100%;
  max-width: initial;
  margin-bottom: measure(quarter);

  @include media(small) {
    width: 14rem;
    margin-bottom: 0;
    margin-right: measure(half);
  }
}
</style>
